"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbnailRatio = void 0;
exports.getThumbnailRatio = getThumbnailRatio;
/**
 * 섬네일의 가로 세로 비율
 * e.g. 가로 3 세로 2 일 경우 = 3/2 = 1.5
 * 풍경화(세로가 긴), 인물화, 정방형 비율이 있습니다.
 */
var ThumbnailRatio;
(function (ThumbnailRatio) {
    ThumbnailRatio[ThumbnailRatio["PORTRAIT"] = 0.8] = "PORTRAIT";
    ThumbnailRatio[ThumbnailRatio["SQUARE"] = 1] = "SQUARE";
    ThumbnailRatio[ThumbnailRatio["LANDSCAPE"] = 1.2] = "LANDSCAPE";
})(ThumbnailRatio || (exports.ThumbnailRatio = ThumbnailRatio = {}));
function getThumbnailRatio(input) {
    const width = input.width || 1;
    const height = input.height || 1;
    const ratio = width / height;
    if (ratio >= ThumbnailRatio.LANDSCAPE)
        return ThumbnailRatio.LANDSCAPE;
    if (ratio <= ThumbnailRatio.PORTRAIT)
        return ThumbnailRatio.PORTRAIT;
    return ThumbnailRatio.SQUARE;
}
